"use strict";
import "../../api/api";
import DisablingButton from "../../components/disabling_button";
import InvoiceAbandonerReason from "./invoice_abandoner_reason";
import InvoiceAbandonerRadioGroup from "./invoice_abandoner_radio_group";
const InvoiceAbandonerForm = ({
  abandon,
  abandoning,
  duplicateInvoice,
  error,
  isPaymentsNetworkSubmission,
  onCancel,
  onChangeOption,
  onChangeReason,
  reason,
  selectedOption
}) => {
  return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement(
    InvoiceAbandonerReason,
    {
      error,
      isPaymentsNetworkSubmission: !!isPaymentsNetworkSubmission,
      onChange: onChangeReason,
      selectedOption,
      value: reason
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "small-12 column" }, duplicateInvoice && /* @__PURE__ */ React.createElement(
    InvoiceAbandonerRadioGroup,
    {
      duplicateInvoice,
      onChangeOption,
      selectedOption
    }
  ), /* @__PURE__ */ React.createElement(
    DisablingButton,
    {
      className: "button--confirmation",
      disabled: abandoning,
      disabledText: "Ignoring...",
      onClick: abandon
    },
    "Ignore Invoice"
  ), /* @__PURE__ */ React.createElement("span", { className: "button--cancel-wrapper" }, "or", /* @__PURE__ */ React.createElement("button", { onClick: onCancel, className: "button--cancel" }, "cancel"))));
};
export default InvoiceAbandonerForm;
